import { useEffect } from "react"
import { useStore } from "../../../state/store"

function SetVis() {
  const setVisible = useStore(state => state.setVisible)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)
  const setActiveApt = useStore(state => state.setActiveApt)
  const setActiveFloors = useStore(state => state.setActiveFloors)
  const setActiveBlock = useStore(state => state.setActiveBlock)

  useEffect(() => {
    setVisible && setVisible(true)

    return () => {
      setVisible && setVisible(false)
      setFavouritesActive(false)
      setFavouritesActive(false)
      setActiveApt(null)
      setActiveFloors(null)
      setActiveBlock(null)
    }
  }, [])

  return null
}

export default SetVis
